// extracted by mini-css-extract-plugin
export default {"connect":"ConnectForm_connect__S2vBx","connect__control":"ConnectForm_connect__control__KDjGZ","highlight":"ConnectForm_highlight__9804B","btn":"ConnectForm_btn__TXp0t"};